<template>
  <div class="flow-page">
    <!-- 附加单据 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">出库单</h2>
          <div class="header-sub">OUTBOUND ORDER</div>
        </div>
      </div>
      <div class="card-body">
        <OutEntrepot :outEntrepotId="outEntrepotId" />
      </div>
    </div>

    <!-- 流程图 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">流程图</h2>
          <div class="header-sub">PROCESS DIAGRAM</div>
        </div>
      </div>
      <div class="card-body">
        <div class="tu-class">
          <p v-html="str" class="p-class">{{str}}</p>
        </div>
      </div>
    </div>

    <!-- 流程历史跟踪 -->
    <div class="table-container">
      <div class="page-header flow-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">流程历史跟踪</h2>
          <div class="header-sub">PROCESS HISTORY</div>
        </div>
      </div>
      <div class="flow-table-wrap">
        <el-table :data="tableData" border>
          <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="activityName" label="名称" align="center"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
          <el-table-column prop="assignee" label="负责人" align="center"></el-table-column>
          <el-table-column prop="status" label="处理结果" align="center"></el-table-column>
          <el-table-column prop="reason" label="处理意见" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { processInstanceImage } from "@/api/api.js";
  import { historicActivityInstance } from "@/api/api.js";
  import OutEntrepot from "./info/OutEntrepot.vue";

  export default {
    components: {OutEntrepot},
    data() {
      return{
        id: this.$route.query.id,
        processId: this.$route.query.processId,
        outEntrepotId: this.$route.query.id,
        str:"",
        tableData:[]
      }
    },
    methods: {
      initData(){
        if (this.processId) {
          let params = {processInstanceId: this.processId};
          processInstanceImage(params).then(res=>{
            this.str = res.data
          });
          historicActivityInstance(params).then(res=>{
            if (res.data.code == 200) {
              this.tableData = res.data.data;
              this.tableData.map((item, index)=>{
                item.ids = index + 1;
              })
            }
          });
        }
      },
    },
    mounted() {
      this.initData()
    },
  };
</script>

<style scoped lang="less">
  @primary: #409EFF;
  @primary-dark: #337ECC;
  @text-primary: #303133;
  @bg-page: #F0F2F5;
  @bg-header: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);

  .flow-page {
    min-height: 100vh;
    background: @bg-page;
    padding: 24px 16px 40px;
    box-sizing: border-box;
  }

  /* ================= 容器 ================= */
  .table-container {
    max-width: 1200px;
    margin: 0 auto 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;
  }

  /* ================= 标题区域 ================= */
  .page-header {
    display: flex;
    align-items: center;
    padding: 20px 28px;
    background: @bg-header;
    color: #fff;
    &.flow-header {
      padding: 16px 28px;
      .header-title {
        font-size: 18px;
      }
    }
  }
  .header-bar {
    width: 5px;
    height: 36px;
    background: #fff;
    border-radius: 3px;
    margin-right: 14px;
    opacity: 0.85;
  }
  .header-content {
    flex: 1;
  }
  .header-title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 2px;
    line-height: 1.2;
  }
  .header-sub {
    margin-top: 4px;
    font-size: 12px;
    letter-spacing: 1.5px;
    opacity: 0.7;
  }

  /* ================= 卡片内容区 ================= */
  .card-body {
    padding: 16px;
  }

  .tu-class {
    padding: 0;
    .p-class {
      margin: 0;
      /deep/ img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  /* ================= 流程表格 ================= */
  .flow-table-wrap {
    padding: 16px;
  }
</style>
